import _ from 'lodash'
import React, { PropsWithChildren, useEffect } from 'react'
import { ConnectedProps, connect } from 'react-redux'
import { compose } from 'recompose'

import auth from 'utils/auth'
import { generateRoute } from 'utils/routing'

import { withRouter, withRouterProps } from 'services/router'
import { withShellService, withShellServiceProps } from 'services/shell'

import i18n from 'translations'

import MedicationFormWrapper from './MedicationForm/MedicationFormWrapper'
import SafeguardingWrapperView from './SafeguardingWrapperView'

const mapState = (state) => ({
  authAccessMap: {
    module: {
      MedicationForm: auth.SELECTORS.getComponentIsAuthorised(state, MedicationFormWrapper),
    },
  },
})

const connector = connect(mapState)

type PropsFromRedux = ConnectedProps<typeof connector>

type SafeguardingWrapperContainerProps = PropsFromRedux
  & withShellServiceProps
  & withRouterProps

const SafeguardingWrapperContainer: React.FC<PropsWithChildren<SafeguardingWrapperContainerProps>> = ({
  authAccessMap,
  children,
  location,
  navigate,
  shellActions,
}) => {
  const { pathname } = location

  const setMenu = () => {
    shellActions.setSubMenu([
      {
        icon: 'injury-records',
        label: _.startCase(i18n.t('module:Safeguarding:Routing:accidentsIncidents')),
        to: generateRoute('SAFEGUARDING.INJURY.LIST'),
      },
      {
        icon: 'home-accidents',
        label: _.startCase(i18n.t('module:Safeguarding:Routing:homeAccidents')),
        to: generateRoute('SAFEGUARDING.HOME_ACCIDENTS.LIST'),
      },
      {
        hidden: !authAccessMap.module.MedicationForm,
        icon: 'medication',
        label: i18n.t('module:Safeguarding:MedicationForm:title'),
        to: generateRoute('SAFEGUARDING.MEDICATION_FORM.LIST'),
      },
      {
        hidden: !authAccessMap.module.MedicationForm,
        icon: 'administration',
        label: i18n.t('module:Safeguarding:Administration:title'),
        to: generateRoute('SAFEGUARDING.ADMINISTRATION.LIST'),
      },
    ])
  }

  useEffect(() => {
    setMenu()
  }, [])

  useEffect(() => {
    if (generateRoute('SAFEGUARDING.INDEX') === pathname) {
      navigate(generateRoute('SAFEGUARDING.INJURY.LIST'))
    }
  }, [pathname])

  return (
    <SafeguardingWrapperView>
      {children}
    </SafeguardingWrapperView>
  )
}

const enhance = compose(
  withRouter,
  withShellService,
  connector,
)

export default enhance(SafeguardingWrapperContainer)
